import { GetCsvExcelTradesHistoryApi } from "@/features/accounts/csv-excel/services/get-trades-history-api";
import { GetCsvExcelTradesHistoryRequestModel } from "@/features/accounts/csv-excel/services/get-trades-history-model";

/// csv/Excel取込履歴取得処理
export class GetCsvExcelTradesHistoryService {
    private getCsvExcelTradesHistoryApi = new GetCsvExcelTradesHistoryApi();

    /**
     * csv/Excel取込履歴取得API実行
     */
    public async getCsvExcelTradesHistory(param: GetCsvExcelTradesHistoryRequestModel) {
        return await this.getCsvExcelTradesHistoryApi.getCsvExcelTradesHistory(param);
    }
}
